import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

// SERVICES
import { IInvoice } from '../../../../invoice/interfaces/invoice.interface';
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

//INTERFACE

@Injectable({
  providedIn: 'root',
})
export class ClientPurchaseOrderApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _submittingForm = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _purchaseOrders = new BehaviorSubject<IInvoice[]>(
    <IInvoice[]>[],
  );
  private readonly _currentPurchaseOrder = new BehaviorSubject<any>(<any>null);

  loading$ = this._loading.asObservable();
  submittingForm$ = this._submittingForm.asObservable();
  currentPurchaseOrder$ = this._currentPurchaseOrder.asObservable();
  environment = this.environmentUtilService.getEnvironment();
  purchaseOrders$ = this._purchaseOrders.asObservable();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  // TODO: CREATE TYPES
  create(payload :any) :Observable<any> {
    this._submittingForm.next(true);

    return this.apiService
      .post({
        path: `${this.environment.urlV1}/clients/purchase_orders`,
        body: payload,
      })
      .pipe(
        map((response :any) => {
          this._submittingForm.next(false);

          return response;
        }),
        catchError((response) => {
          this._submittingForm.next(false);

          return throwError(response);
        }),
      );
  }

  getById(id :number) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/clients/purchase_orders/${id}`)
      .subscribe({
        next: (response :any) => {
          this._currentPurchaseOrder.next(response);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  update(data :{ id :number; payload :any }) :Observable<any> {
    const { id, payload } = data;
    this._submittingForm.next(true);

    return this.apiService
      .post({
        path: `${this.environment.urlV1}/clients/purchase_orders/${id}`,
        body: payload,
      })
      .pipe(
        tap(() => this._submittingForm.next(false)),
        catchError((response) => {
          this._submittingForm.next(false);

          return throwError(() => response);
        }),
      );
  }

  approve(id :number) :Observable<any> {
    this._submittingForm.next(true);

    return this.apiService
      .post({
        path: `${this.environment.urlV1}/clients/purchase_orders/${id}/approve-po`,
      })
      .pipe(
        map((response :any) => {
          this._submittingForm.next(false);

          return response;
        }),
        catchError((response) => {
          this._submittingForm.next(false);

          return throwError(response);
        }),
      );
  }

  reject(id :number) :Observable<any> {
    this._submittingForm.next(true);

    return this.apiService
      .post({
        path: `${this.environment.urlV1}/clients/purchase_orders/${id}/reject-po`,
      })
      .pipe(
        map((response :any) => {
          this._submittingForm.next(false);

          return response;
        }),
        catchError((response) => {
          this._submittingForm.next(false);

          return throwError(response);
        }),
      );
  }

  // TODO: Creat type
  setCurrentPurchaseOrder(purchaseOrder :any) :void {
    this._currentPurchaseOrder.next(purchaseOrder);
  }

  get(params :{ [param :string] :string | string[] | any }) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/clients/purchase_orders`, {
        params,
      })
      .subscribe({
        next: (response :any) => {
          this._purchaseOrders.next(response.data);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }
}
